import React from 'react';
import { EmailBlock, SocialBlockContent } from '../types';
import { Facebook, Twitter, Instagram, Linkedin, Youtube } from 'lucide-react';

interface SocialBlockProps {
  block: EmailBlock;
  isSelected: boolean;
  onSelect: () => void;
  isDarkMode: boolean;
}

const SOCIAL_ICONS = {
  facebook: Facebook,
  twitter: Twitter,
  instagram: Instagram,
  linkedin: Linkedin,
  youtube: Youtube
};

export const SocialBlock: React.FC<SocialBlockProps> = ({
  block,
  isSelected,
  onSelect,
  isDarkMode
}) => {
  const content = block.content as SocialBlockContent;

  const containerStyle: React.CSSProperties = {
    textAlign: content.align || 'center',
    padding: '20px',
    ...block.styles
  };

  const iconSize = content.iconSize || 32;
  const iconColor = content.iconColor || '#000000';
  const spacing = content.spacing || 10;

  if (!content.platforms || content.platforms.length === 0) {
    return (
      <div style={containerStyle} className={`
        border-2 border-dashed rounded
        ${isDarkMode ? 'border-gray-600' : 'border-gray-300'}
      `}>
        <p className={`
          text-sm
          ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}
        `}>
          No social platforms added
        </p>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={{ display: 'inline-flex', gap: `${spacing}px` }}>
        {content.platforms.map((platform, index) => {
          const Icon = SOCIAL_ICONS[platform.platform];
          if (!Icon) return null;

          return (
            <a
              key={index}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: iconColor,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Icon size={iconSize} />
            </a>
          );
        })}
      </div>
    </div>
  );
};
